var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dj-border-bottom dj-drawer-header"},[_c('div',{staticClass:"dj-user-select dj-border-right dj-drawer-header__left",on:{"click":_vm.closeHandle}},[_c('dj-media-icon',{attrs:{"media":"arrow-left"}}),_c('div',[_vm._v("关闭")])],1),_c('div',{staticClass:"dj-drawer-header__right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }